import React, { useState } from "react";
import Button from "@mostrans/web-components/components/base/Button";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import PreviewIcon from "@mui/icons-material/Preview";
import "./assets/papikostik.css";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ChartPapikostik from "../ChartPapikostik/ChartPapikostik";
import Table from "@mostrans/web-components/components/base/Table";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useGetdetailOpportunity } from "../../../../GQL/Opportunity/hooks/useGetdetailOpportunity";
import moment from "moment";

function ModalPdfPapikostik(props) {
  const [openModal, setOpenModal] = useState(false);
  const { dataCandidateByID } = props;
  const { opportunityID } = useParams();
  const [detailOpportunity] = useGetdetailOpportunity(parseInt(opportunityID));

  console.log(dataCandidateByID);

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const getCanvasData = (element) => {
    return new Promise((resolve, reject) => {
      html2canvas(element, { scale: 2, logging: true })
        .then(function (canvas) {
          resolve(canvas.toDataURL("img/png"));
        })
        .catch(function (error) {
          reject(
            "Error while creating canvas for element with ID: " + element.id
          );
        });
    });
  };

  const createPdf = () => {
    let pdf = new jsPDF({
      orientation: "p",
      unit: "mm",
      format: "a4",
      compression: true,
    });

    let pageIds = ["divToPrint1", "divToPrint2", "divToPrint3"];
    let promises = [];
    pageIds.map((page) => {
      promises.push(getCanvasData(document.getElementById(page)));
    });
    let width = pdf.internal.pageSize.getWidth();
    let height = pdf.internal.pageSize.getHeight();

    Promise.all(promises).then((dataUrls) => {
      dataUrls.map((dataUrl) => {
        pdf.addImage(dataUrl, "PNG", 0, 0, width, height, undefined, "FAST");
        pdf.addPage();
      });
      let pageCount = pdf.internal.getNumberOfPages();
      pdf.deletePage(pageCount);
      pdf.save("psikotest-result.pdf");
    });
  };

  const dimensionsData = dataCandidateByID?.Papikostik?.reduce((acc, item) => {
    const dimension = getDimension(item.code); // Utility function to get dimension by code
    if (!acc[dimension]) {
      acc[dimension] = [];
    }
    acc[dimension].push(item);
    return acc;
  }, {});

  function getDimension(code) {
    switch (code) {
      case "A":
      case "N":
      case "G":
        return "Work Direction";
      case "L":
      case "P":
      case "I":
        return "Leadership";
      case "T":
      case "V":
        return "Activity";
      case "S":
      case "B":
      case "O":
      case "X":
        return "Social Nature";
      case "C":
      case "D":
      case "R":
        return "Workstyle";
      case "E":
      case "K":
      case "Z":
        return "Temperament";
      case "W":
      case "F":
        return "Followership";
      default:
        return "Other";
    }
  }

  const dimensionOrders = [
    "Work Direction",
    "Workstyle",
    "Activity",
    "Followership",
    "Leadership",
    "Social Nature",
    "Temperament",
  ];

  const dimensionOrder = {
    "Work Direction": ["A", "N", "G"],
    Workstyle: ["C", "D", "R"],
    Activity: ["T", "V"],
    Followership: ["W", "F"],
    Leadership: ["L", "P", "I"],
    "Social Nature": ["S", "B", "O", "X"],
    Temperament: ["E", "K", "Z"],
  };

  return (
    <React.Fragment>
      <Button
        color="primary"
        startIcon={<PreviewIcon />}
        onClick={handleOpenModal}
      >
        Preview to Export
      </Button>
      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        fullWidth="xl"
        maxWidth="xl"
      >
        <DialogTitle>Preview To Export Papikostik Result</DialogTitle>
        <DialogContent>
          <div className="row">
            <div
              className="col-md-12"
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button
                color="primary"
                startIcon={<FileDownloadOutlinedIcon />}
                onClick={createPdf}
              >
                Save to PDF
              </Button>
            </div>
          </div>
          <div className="book">
            <div className="page" id="divToPrint1">
              <div className="subpage">
                <div className="row">
                  <div className="col-md-12 mb-2">
                    <Typography>
                      <b>Psikotest Result</b>
                    </Typography>
                    <Typography>
                      Nama : {dataCandidateByID?.full_name}
                    </Typography>
                    <Typography>
                      Tanggal :{" "}
                      {moment(dataCandidateByID?.psikotest_date).format(
                        "DD MMMM YYYY"
                      )}
                    </Typography>
                    <Typography>
                      Posisi : {detailOpportunity?.data.title}
                    </Typography>
                    <Typography>
                      Pendidikan : {dataCandidateByID?.Educations[0]?.degree}
                    </Typography>
                  </div>
                  <div className="col-md-12">
                    <Typography>A. Papikostik Chart</Typography>
                  </div>
                  <div style={{ width: 500, marginLeft: "70px" }}>
                    <ChartPapikostik dataCandidateByID={dataCandidateByID} />
                  </div>
                  <div className="col-md-12">
                    <Typography>B. Papikostik Table</Typography>
                  </div>
                  <div className="col-md-12 mt-1">
                    <Table>
                      <thead style={{ fontSize: "14px" }}>
                        <tr>
                          <th>Dimensions</th>
                          <th>Aspects</th>
                          <th>Score</th>
                          <th>Interpretation</th>
                        </tr>
                      </thead>
                      <tbody style={{ fontSize: "12px" }}>
                        {dimensionsData &&
                        Object.keys(dimensionsData).length > 0 ? (
                          Object.entries(dimensionsData)
                            // Sort the dimensions based on the pre-defined order in 'dimensionOrder'
                            .sort(([a], [b]) => {
                              const orderA = dimensionOrders.indexOf(a);
                              const orderB = dimensionOrders.indexOf(b);
                              return orderA - orderB;
                            })
                            // Take only the first two dimensions
                            .slice(0, 2)
                            // Render the items for each dimension
                            .map(([dimension, items]) => {
                              // Sort the items within each dimension if needed (optional)
                              const orderedItems = items.sort((a, b) => {
                                const order = dimensionOrder[dimension];
                                if (!order) return 0; // If no specific order, leave unsorted
                                return (
                                  order.indexOf(a.code) - order.indexOf(b.code)
                                );
                              });

                              return orderedItems.map((item, index) => (
                                <tr
                                  key={item.id} // Use item.id for uniqueness
                                  style={{
                                    backgroundColor: "transparent",
                                  }}
                                >
                                  {index === 0 && (
                                    <td rowSpan={orderedItems.length}>
                                      {dimension}
                                    </td>
                                  )}
                                  <td>
                                    ({item.code}) {item.aspect}
                                  </td>
                                  <td>{item.score}</td>
                                  <td>{item.interpretation}</td>
                                </tr>
                              ));
                            })
                        ) : (
                          <tr>
                            <td colSpan="4" style={{ textAlign: "center" }}>
                              No Data Available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </div>
            <div className="page" id="divToPrint2">
              <div className="subpage">
                <div className="row">
                  <div className="col-md-12 mt-1">
                    <Table>
                      <thead style={{ fontSize: "14px" }}>
                        <tr>
                          <th>Dimensions</th>
                          <th>Aspects</th>
                          <th>Score</th>
                          <th>Interpretation</th>
                        </tr>
                      </thead>
                      <tbody style={{ fontSize: "12px" }}>
                        {dimensionsData &&
                        Object.keys(dimensionsData).length > 0 ? (
                          Object.entries(dimensionsData)
                            // Sort the dimensions based on the pre-defined order in 'dimensionOrder'
                            .sort(([a], [b]) => {
                              const orderA = dimensionOrders.indexOf(a);
                              const orderB = dimensionOrders.indexOf(b);
                              return orderA - orderB;
                            })
                            .slice(2, 7)
                            // Render the items for each dimension
                            .map(([dimension, items]) => {
                              // Sort the items within each dimension if needed (optional)
                              const orderedItems = items.sort((a, b) => {
                                const order = dimensionOrder[dimension];
                                if (!order) return 0; // If no specific order, leave unsorted
                                return (
                                  order.indexOf(a.code) - order.indexOf(b.code)
                                );
                              });

                              return orderedItems.map((item, index) => (
                                <tr
                                  key={item.id} // Use item.id for uniqueness
                                  style={{
                                    backgroundColor: "transparent",
                                  }}
                                >
                                  {index === 0 && (
                                    <td rowSpan={orderedItems.length}>
                                      {dimension}
                                    </td>
                                  )}
                                  <td>
                                    ({item.code}) {item.aspect}
                                  </td>
                                  <td>{item.score}</td>
                                  <td>{item.interpretation}</td>
                                </tr>
                              ));
                            })
                        ) : (
                          <tr>
                            <td colSpan="4" style={{ textAlign: "center" }}>
                              No Data Available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </div>
            <div className="page" id="divToPrint3">
              <div className="subpage">
                <div className="row">
                  <div className="col-md-12 mt-2">
                    <Typography>C. CFIT Result</Typography>
                    {dataCandidateByID.CFIT ? (
                      <div style={{ marginTop: "50mm" }}>
                        <h1
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          IQ : {dataCandidateByID.CFIT.iq}
                        </h1>
                        <h1
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            color: "#0A8C4A",
                          }}
                        >
                          Result : {dataCandidateByID.CFIT.result}
                        </h1>
                      </div>
                    ) : (
                      <p>Hasil CFIT Belum Tersedia</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="error" onClick={handleCloseModal}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default ModalPdfPapikostik;
